import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Form,
} from 'semantic-ui-react';

class FormOptionsCallback extends Component {
  constructor() {
    super();

    this.state = {
      showOptionsControls: false,
    };
  }

  toggleShowOptionsControls = () => {
    this.setState(prevState => ({ showOptionsControls: !prevState.showOptionsControls }));
  }

  renderCallbackOptions = () => {
    const { data, updateDataField } = this.props;
    return (
      <div>
        <Form.Input
          id="j-callbackUrlInput"
          label="Callback URL"
          type="url"
          value={data.callback_url || ''}
          onChange={
            (event, eventData) => {
              updateDataField('callback_url', eventData.value);
            }
          }
        />
        <Form.Field>
          <Checkbox
            toggle
            label="Enable email_callback"
            checked={
              (data.email_callback) || false
            }
            onChange={
              (event, eventData) => {
                updateDataField('email_callback', eventData.checked);
              }
            }
          />
        </Form.Field>
        <div id="j-callbackOptions" className="re is-marginTop-16px">
          <Form.Input
            label="User Token (eg. used for tagging)"
            value={data.user_token || ''}
            onChange={
            (event, eventData) => { updateDataField('user_token', eventData.value); }
          }
          />
          <Form.Input
            label="User Secret (used for HMAC-SHA1 signature verification)"
            value={data.user_secret || ''}
            onChange={
            (event, eventData) => { updateDataField('user_secret', eventData.value); }
          }
          />
          <Form.Input
            label="Basic Auth Username"
            value={data.basic_auth_username || ''}
            onChange={
            (event, eventData) => { updateDataField('basic_auth_username', eventData.value); }
          }
          />
          <Form.Input
            label="Basic Auth Password"
            value={data.basic_auth_password || ''}
            onChange={
            (event, eventData) => { updateDataField('basic_auth_password', eventData.value); }
          }
          />
          <Form.Field>
            <Checkbox
              toggle
              label='Notify on "started"'
              checked={
              (data.events && data.events.started) || false
            }
              onChange={
              (event, eventData) => { updateDataField('events', eventData.checked, 'started'); }
            }
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              toggle
              label='Notify on "failed"'
              checked={
              (data.events && data.events.failed) || false
            }
              onChange={
              (event, eventData) => { updateDataField('events', eventData.checked, 'failed'); }
            }
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              toggle
              label='Notify on "completed"'
              checked={
              (data.events && data.events.completed) || false
            }
              onChange={
              (event, eventData) => { updateDataField('events', eventData.checked, 'completed'); }
            }
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              toggle
              label='Notify on "completed_with_results"'
              checked={
              (data.events && data.events.completed_with_results) || false
            }
              onChange={
              (event, eventData) => {
                updateDataField('events', eventData.checked, 'completed_with_results');
              }
            }
            />
          </Form.Field>
        </div>
      </div>
    );
  }

  /* Note this must be used inside a <Form> */
  render() {
    const { showOptionsControls } = this.state;
    return (
      <div id="j-callbackField">
        <Button onClick={() => { this.toggleShowOptionsControls(); }}>
          { showOptionsControls ? 'Hide Callback Options' : 'Show Callback Options' }
        </Button>
        { showOptionsControls && this.renderCallbackOptions() }
      </div>
    );
  }
}

FormOptionsCallback.propTypes = {
  data: PropTypes.shape({
    basic_auth_username: PropTypes.string,
    basic_auth_password: PropTypes.string,
    callback_email: PropTypes.string,
    callback_url: PropTypes.string,
    events: PropTypes.shape({
      completed: PropTypes.bool,
      completed_with_results: PropTypes.bool,
      failed: PropTypes.bool,
      started: PropTypes.bool,
    }),
    user_token: PropTypes.string,
    user_secret: PropTypes.string,
  }).isRequired,
  updateDataField: PropTypes.func.isRequired,
};

export default FormOptionsCallback;
